import basicStorage from '@/utils/basicStorage';

const AUTH_SESSION_EPOCH_KEY = 'auth-session-epoch';

const createEpoch = () => `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export const getAuthSessionEpoch = () => {
  let epoch = basicStorage.getItem(AUTH_SESSION_EPOCH_KEY);
  if (!epoch) {
    epoch = createEpoch();
    basicStorage.setItem(AUTH_SESSION_EPOCH_KEY, epoch);
  }
  return epoch;
};

export const rotateAuthSessionEpoch = () => {
  const epoch = createEpoch();
  basicStorage.setItem(AUTH_SESSION_EPOCH_KEY, epoch);
  return epoch;
};

